// Supermove
import {UserModel} from '@supermove/models';

// App
import UserStatus from '@shared/modules/User/enums/UserStatus';
import {SelectedUserStatusType} from 'modules/Organization/Settings/Staff/types';

export const getOfficeUsers = ({
  selectedUserStatus,
  activeUsers,
  pendingUsers,
  inactiveUsers,
}: {
  selectedUserStatus: SelectedUserStatusType;
  activeUsers: UserModel[];
  pendingUsers: UserModel[];
  inactiveUsers: UserModel[];
}) => {
  switch (selectedUserStatus) {
    case UserStatus.ACTIVE:
      return activeUsers;
    case UserStatus.PENDING:
      return pendingUsers;
    case UserStatus.INACTIVE:
      return inactiveUsers;
    default:
      return [];
  }
};

export default {
  getOfficeUsers,
};
